import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import { select } from '../Redux/Actions'
import store from '../Redux';
import LoaderButton from './LoaderButton';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = theme => ({
    dialog: {
        overflow: "initial"
    },
})

class DialogContainer extends React.Component {

    state = {
        open: false,
        isLoading: false
    }

    constructor(props) {
        super(props)
        this.state = {
            ...this.state, ...props
        }
    }

    componentWillReceiveProps(props) {
        var loading = this.state.isLoading
        if(props.open === true && this.state.open !== props.open) {
            loading = false
            this.subscribe()
        }
        this.setState({
            ...props, isLoading: loading
        })
        if(props.open === false && this.unsubscribe !== undefined) {
            this.unsubscribe()
        }
    }

    subscribe = () => {
        this.unsubscribe = store.subscribe(() => {
                var state = select(store.getState(), "generic")
                this.setState({
                    ...state
                })
            }
        )
    }

    closeAction = () => {
        if(this.unsubscribe !== undefined) {
            this.unsubscribe()
        }
        this.state.closeAction()
    }

    saveAction = () => {
        this.state.saveAction()
    }

    render() {
        var classes = this.props.classes
        var {
            title, text, closeAction, children, isLoading
        } = this.state
        return(
            <Dialog
                {...this.props}
                open={this.state.open}
                onClose={closeAction}
                aria-labelledby="form-dialog-title"
                classes={this.props.classesObject}
                scroll="body"
                maxWidth={this.props.maxWidth}
            >
                <DialogTitle id="form-dialog-title">{title}</DialogTitle>
                <DialogContent className={classes.dialog}>
                    {text && <DialogContentText>{text}</DialogContentText>}
                    {children}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeAction} color="secondary">Abbrechen</Button>
                    <LoaderButton disabled={this.props.disabled} name="Speichern" color="primary" onClick={this.saveAction} loading={isLoading} />
                </DialogActions>
            </Dialog>
        )
    }

}

const mapStateToProps = state => ({
    ...state
})
export default connect(
    mapStateToProps,
    {}
)(withStyles(styles)(DialogContainer));



// WEBPACK FOOTER //
// ./src/Components/Dialog.js